const id = 0;
const indexElement = document.getElementById("sm-surveytool");

const config = {
  id:  indexElement?.getAttribute("data-id") ,

};

export default config;
